import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Skeleton } from 'components/ui/skeleton';
import { useCommonStore } from 'state/store/common/useCommonStore';
import { BillingDetailsCard } from 'features/subscription/components/billing-details-card';
import { useMyPlan, usePlanSeats } from 'features/subscription/hooks/use-seats';
import { OrgPlansCard } from './org-plans-card';
import { YourPlanCard } from './your-plan-card';

/** Figma "Account / Subscription" (10827:25988). Everyone sees their own seat; admins also manage the organization's plans and billing details. */
export function AccountSubscriptionTab() {
  const { t } = useTranslation();
  const isAdmin = useCommonStore((state) => state.isAdmin);
  const { place, isLoading: isPlaceLoading } = useMyPlan();
  const { planSeats, isLoading: isPlansLoading } = usePlanSeats();

  if (isPlaceLoading || isPlansLoading) {
    return (
      <div className="flex flex-col gap-4">
        <Skeleton className="h-32 rounded-section" />
        <Skeleton className="h-64 rounded-section" />
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4">
      <YourPlanCard place={place} planSeats={planSeats} isAdmin={isAdmin} />

      {isAdmin && (
        <>
          <OrgPlansCard planSeats={planSeats} />
          <BillingDetailsCard
            description={t('BILLING_DETAILS_ON_EVERY_INVOICE', 'On every invoice. The same details as Plans & Billing.')}
            footer={
              <p className="text-sm leading-body text-grey-600 dark:text-muted-foreground">
                {t('PAYMENT_AND_INVOICES_ARE_IN', 'Payment method and invoices are in')}{' '}
                <Link to="/plans-billing" className="font-medium text-grey-950 hover:underline dark:text-foreground">
                  {t('PLANS_AND_BILLING', 'Plans & Billing')}
                </Link>
                .
              </p>
            }
          />
        </>
      )}
    </div>
  );
}
